import _axios from "../index";
import { API_ROUTES } from "../../../utils/constants";


export default class orgAuthService {
  login = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.ORGANIZATION.LOGIN_ORG, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  SignUp = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.ORGANIZATION.SIGN_UP_ORG, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  GET_ORGANIZATION = async () => {
    try {
      const response = await _axios.get(API_ROUTES.ORGANIZATION.GET_ORGANIZATION);
      return response;
    } catch (err) {
      throw err;
    }
  };

  GoogleAuthLogin = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.AUTHENTICATION.GOOGLE_LOGIN, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  GenerateOTP = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.AUTHENTICATION.GENERATE_OTP, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  VerifyOTP = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.AUTHENTICATION.VERIFY_OTP, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  logout = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.AUTHENTICATION.LOGOUT_AUTH, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Send_reset_password_link_org = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.ORGANIZATION.RESET_PASSWORD_APPLY_ORG, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Change_password_org = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.ORGANIZATION.CHANGE_PASSWORD_ORG, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_Permissions = async () => {
    try {
      const response = await _axios.get(API_ROUTES.ORGANIZATION.GETPERMISSIONS);
      return response;
    } catch (err) {
      throw err;
    }
  };

 Add_Respresentative_User = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.ORGANIZATION.ADD_REPRESENTATAIVE_USER, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_Bind_User = async () => {
    try {
      const response = await _axios.get(API_ROUTES.ORGANIZATION.GET_BIND_USERS);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Remove_Bind_User = async (body) => {
    try {
      const response = await _axios.delete(API_ROUTES.ORGANIZATION.REMOVE_BIND_USER, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_Roles = async () => {
    try {
      const response = await _axios.get(API_ROUTES.ROLES.GET_ROLES);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_applications = async (applicationId) => {
    try {
      const response = await _axios.get(`${API_ROUTES.ORGANIZATION.GET_APLICATIONS}/${applicationId}`);
      return response;
    } catch (err) {
      throw err;
    }
  };
}
